import { BluetoothProxy } from "@/utils/bluetooth";
import { ESP32BLE, ESP32BLE_OTA_UPDATE, HEARTBEAT, OUTPUT, SERVICE } from "./define";
import { BluetoothPluginProxy } from "@/utils/capacitor/bluetoothPlugin";
import { isNative } from "@/utils/capacitor";
// import { toHex } from "@/utils/math";

// normal options for BluetoothProxy
export const ESP32Options = {
  bluetoothRawOptions: [ESP32BLE],
};
// updated ota options for BluetoothProxy
export const ESP32OTAUpdateOptions = {
  bluetoothRawOptions: [ESP32BLE_OTA_UPDATE],
};
export const ESP32BLEBluetooth = isNative? new BluetoothPluginProxy(ESP32Options) : new BluetoothProxy(ESP32Options);

// export const ESP32BLEBluetooth = new BluetoothProxy(ESP32Options);

(window as any).ESP32BLEBluetooth = ESP32BLEBluetooth;

export async function readData() {
  try {
    const value = await ESP32BLEBluetooth.queuePerformReadData(
      SERVICE.uuid,
      OUTPUT.uuid
    );
    if (value) return value as DomianControl.OutputValue;
    return null;
  } catch (error) {
    console.error("[API] readData Error:", error);
  }
}
export async function writeData(data: DomianControl.OutputParams) {
  console.log("[BOWEN_LOG] 🚀 ~~ writeData ~~ data:", data);
  try {
    await ESP32BLEBluetooth.queuePerformWriteData(
      data,
      SERVICE.uuid,
      OUTPUT.uuid
    );
    // const value = await ESP32BLEBluetooth.readData(SERVICE.uuid, OUTPUT.uuid);
    // console.log("[BOWEN_LOG] 🚀 ~~ writeData ~~ readData:", value);
    const value = data;
    return value;
  } catch (error) {
    console.error("[API] writeData Error:", error);
  }
}
export async function heartbeat(data: DomianControl.OutputParams) {
  console.log("[BOWEN_LOG] 🚀 ~~ heartbeat ~~ data:", data);
  try {
    if (!ESP32BLEBluetooth.device.gatt?.connected) return;
    await ESP32BLEBluetooth.queuePerformWriteData(
      data,
      SERVICE.uuid,
      HEARTBEAT.uuid,
      { notShowNotify: true }
    );
    const value = data;
    return value;
  } catch (error) {
    console.error("[API] writeData Error:", error);
  }
}
